import { render, staticRenderFns } from "./OsEmPause.vue?vue&type=template&id=bcde284c&"
import script from "./OsEmPause.vue?vue&type=script&lang=js&"
export * from "./OsEmPause.vue?vue&type=script&lang=js&"
import style0 from "./OsEmPause.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports